import { ComponentChild, h } from 'preact'
import Title, { TitleProps } from './Title'

interface Props {
  icon?: ComponentChild,
  buttons?: ComponentChild,
  titleInfo: TitleProps
}

const Header = ({ icon, titleInfo, buttons }: Props) => {
  return (
    <div class='control-header create-topic-page_header'>
      {
        icon ? (
          <div className='topic-type_icon'>
            { icon }
          </div>
        ) : null
      }
      <Title {...titleInfo} />

      {
        buttons || null
      }
    </div>
  )
}

export default Header
